import baseReducer from "@in-core/incore-playbook/src/reducers";
import helloWorld from "./helloWorld";

const aggregatedReducer = {
	...baseReducer,

	// example of adding more reducers specific to this project
	helloWorld: helloWorld
};

export default aggregatedReducer;
